import { render } from "./FilterItem.vue?vue&type=template&id=280b60ec&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"

import "./FilterItem.vue?vue&type=style&index=0&id=280b60ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280b60ec"]])

export default __exports__